import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceActions from '../actions/ecommerce-orders.action';
import {LoadEcommerceOrder} from '../actions/ecommerce-orders.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {OrdersService} from "../../websites/website/ecommerce/orders/orders.service";
import {LoadEcommerceOrders} from "../actions";

@Injectable()
export class EcommerceOrdersEffect {

  loadEcommerceOrders$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_ORDERS),
    mergeMap((action: LoadEcommerceOrders) => {
      const {websiteId, ...params} = action.payload;
      return this._ordersService.getOrders(websiteId, params)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceOrdersSuccess({
                websiteId,
                entities: response.data,
                ordersCount: response.data.ordersTotals.reduce((accumulator, item) => accumulator + item.total, 0)
              });
            }
            return new EcommerceActions.LoadEcommerceOrdersFails({websiteId});
          })
        );
    })
  ));
  loadEcommerceOrder$ = createEffect(() => this._actions$.pipe(
    ofType(EcommerceActions.LOAD_ECOMMERCE_ORDER),
    mergeMap((action: LoadEcommerceOrder) => {
      const {websiteId, id} = action.payload;
      return this._ordersService.getOrderById(websiteId, id)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response.data) {
              return new EcommerceActions.LoadEcommerceOrderSuccess({
                websiteId,
                entities: {...response.data, order: response.data.orders},
              });
            }
            return new EcommerceActions.LoadEcommerceOrderFails({websiteId});
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _ordersService: OrdersService,
  ) {
  }
}
